var _defs, _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "8746e83f-8738-48ce-aad8-5107d98e1418",
    "data-name": "Layer 1",
    viewBox: "0 0 1441.69 1441.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".\\33 6ceac89-cd91-48b4-a4fd-ec0cc44de6be{fill:#fff;stroke:#39526e;stroke-linecap:round;stroke-miterlimit:10;stroke-width:37.57px;}.\\35 d932d4b-47c6-49b3-bb15-1d3a08cc8b5d{fill:#39526e;}.ac1d9021-e636-487d-9296-b51f16b207fd{fill:#eea320;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_Finance_WasteTypes_1500x1500") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "36ceac89-cd91-48b4-a4fd-ec0cc44de6be",
    x: 18.79,
    y: 18.79,
    width: 1404.12,
    height: 1404.12,
    rx: 254.01,
    ry: 254.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "5d932d4b-47c6-49b3-bb15-1d3a08cc8b5d",
    d: "M433.44,529.25s133-264,139.13-273.52,18.52-19.13,30.33-19.5,230.13-5,238.91-4.13,22.36,1.3,32.65,15.81S997.41,431.28,997.41,431.28l87-54.75-63.13,292.79L726.56,601l91-58.51s-78.63-125.37-81.19-129.49-5.76-2.12-13.78,15.54S620.73,632.66,620.73,632.66Z",
    transform: "translate(-31.55 -27.12)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "5d932d4b-47c6-49b3-bb15-1d3a08cc8b5d",
    d: "M1143.74,674.72S1307.24,921,1312.47,931s7.45,25.56,1.92,36-109.61,202.4-114.72,209.6-12.2,18.78-29.91,20.54-220.19,16-220.19,16l4.49,102.69L731,1116.05,936.21,893.81l5.77,108s147.86-6.23,152.7-6.42,4.69-4-6.68-19.67S961.15,786.22,961.15,786.22Z",
    transform: "translate(-31.55 -27.12)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "ac1d9021-e636-487d-9296-b51f16b207fd",
    d: "M674.78,1209.63s-295.25,14.72-306.55,14.09-25.78-6.66-31.94-16.74-118-197.64-121.57-205.71-9.91-20.08-2.38-36.2,98.73-197.46,98.73-197.46L220.52,719l285.77-89.7,86.18,290-95.81-50.23s-70.19,130.29-72.5,134.54,1,6.05,20.32,4.31,227.74-12.21,227.74-12.21Z",
    transform: "translate(-31.55 -27.12)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecycle);
export default __webpack_public_path__ + "static/media/recycle.feb9b9026344baf156399f0a490a4957.svg";
export { ForwardRef as ReactComponent };